<div *ngIf="errorLabel" class="form-error d-flex flex-center">
  {{ errorLabel | i18n | async }}
</div>
